module.exports = __webpack_public_path__ + "img/11.c1971528.jpg";